module.exports = {"513224100":"进安镇","513224101":"川主寺镇","513224102":"青云镇","513224103":"毛儿盖镇","513224200":"进安回族乡","513224201":"十里回族乡","513224203":"安宏乡","513224204":"大寨乡","513224205":"牟尼乡","513224206":"镇江关乡","513224207":"镇坪乡","513224208":"岷江乡","513224209":"大姓乡","513224210":"白羊乡","513224211":"红土乡","513224212":"红扎乡","513224213":"小姓乡","513224214":"燕云乡","513224215":"山巴乡","513224216":"水晶乡","513224217":"小河乡","513224218":"施家堡乡","513224219":"黄龙乡","513224221":"下八寨乡","513224222":"草原乡","513224401":"松潘林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513224.json
// module id = 2402
// module chunks = 0